<template>
  <div class="d-flex col-6" :class="{'disabled' : +info.is_help}" @click="showStarOptions = true">
    <img
      @click="emitContent(option)"
      v-for="option in +info.extension_info.level"
      :key="option"
      class="col-1 mx-1 mt-2"
      :src="imgAry[option - 1]"
    />
  </div>
</template>
<script>
import { ref, watch, onMounted } from '@vue/runtime-core'
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['content'],
  setup(props, { emit }) {
    const iconList = ref(['star', 'heart', 'check', 'good'])
    const getImg = (star) => {
      return new Array(+props.info.extension_info.level)
        .fill('0')
        .map((v, i) => {
          if (i + 1 <= star) {
            return require(`@/assets/icons/${
              iconList.value[props.info.extension_info.type - 1]
            }-color.svg`)
          } else {
            return require(`@/assets/icons/${
              iconList.value[props.info.extension_info.type - 1]
            }.svg`)
          }
        })
    }
    const imgAry = ref(getImg())
    const emitContent = async (score) => {
      if(+props.info.is_help){
        imgAry.value = getImg(props.info.extension_info.level)
      }
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: !!score,
        value_info: !+props.info.is_help && score ? score : null,
      })
      if(!+props.info.is_help){
        imgAry.value = getImg(score)
      }
    }
    onMounted(() => {
      emitContent()
    })
    watch(
      () => props.info.value_info,
      (newVal) => {
        emitContent(newVal)
      },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      emitContent,
      imgAry,
    }
  },
}
</script>
<style lang="scss" scoped>
.title {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #321fdb;
  outline: none;
}
.remark {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #321fdb;
  outline: none;
  font-size: 13px;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.content {
  background-color: #fff !important;
  border: 1px solid #bdbdbd;
}
.wrapper {
  border-left: 5px solid #321fdb;
}
.disabled{
  filter: grayscale(1);
}
</style>
